import { useParams, createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/shared/header";
import { PageContainer } from "@/components/shared/page-container";
import { TaskForm } from "@/components/tasks/task-form";
import { useTask } from "@/lib/api/tasks/hooks";
import { ChevronLeft } from "lucide-react";
import { Link } from "@tanstack/react-router";

function EditTaskPage() {
  const params = useParams({ strict: false });
  const taskId = params.id as string;

  const { data: task, isLoading } = useTask(taskId);

  if (isLoading) {
    return (
      <PageContainer>
        <Header
          title="태스크 수정"
          left={
            <Link to="/tasks" className="p-2 -ml-2">
              <ChevronLeft className="size-6" />
            </Link>
          }
        />
        <div className="bg-card rounded-xl p-6">
          <p className="text-center text-muted-foreground">로딩 중...</p>
        </div>
      </PageContainer>
    );
  }

  if (!task) {
    return (
      <PageContainer>
        <Header
          title="태스크 수정"
          left={
            <Link to="/tasks" className="p-2 -ml-2">
              <ChevronLeft className="size-6" />
            </Link>
          }
        />
        <div className="bg-card rounded-xl p-6">
          <p className="text-center text-muted-foreground">
            태스크를 찾을 수 없습니다.
          </p>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Header
        title="태스크 수정"
        left={
          <Link to="/tasks" className="p-2 -ml-2">
            <ChevronLeft className="size-6" />
          </Link>
        }
      />

      <div className="bg-card rounded-xl p-6">
        <TaskForm mode="edit" task={task} />
      </div>
    </PageContainer>
  );
}

export const Route = createFileRoute("/_content/tasks/$id/edit")({
  component: EditTaskPage,
});
